import CartItemModel from './cartItemModel';
import CartItems from './cartItems';

const addResource = (el) => {
    const {
        title,
        id,
        number,
        language,
    } = el.dataset;

    const model = CartItems.findWhere({
        resourceId: id,
        language,
    });

    if (!model) {
        const cartItem = new CartItemModel({
            resourceId: id,
            number,
            title,
            language,
            selected: true,
            order: CartItems.models.length
                ? CartItems.models.length + 1
                : 1,
        });
        CartItems.add(cartItem);
        cartItem.save();
    }
};

export default addResource;
